import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { Injectable } from '@angular/core';
import { env } from 'process';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NcrService {
  get o3CorebaseUrl(): string { return Constants.CORE_API_BASE_URL; }
  get O3CoreApiUrl(): string { return Constants.CORE_API_BASE_URL; }

  constructor(private http: HttpClient) { }
  getDefectbyPlant(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/DefectByPlant',
      data
    );
  }
  getNcr(): Observable<any[]> {
    return this.http.get<any[]>(this.o3CorebaseUrl + 'NCR/ncr');
  }
  SaveNcrCost(data: any) {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/SaveNcrCost', data);
  }
  addNcr(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/addNcr', data);
  }
  updateNcr(data: any): Observable<any[]> {
    return this.http.put<any[]>(this.o3CorebaseUrl + 'NCR/updateNcr', data);
  }

  getNcrApproval(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/NCRApproval', data);
  }
  deleteNcr(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/deleteNcr', data);
  }
  getNcrType(): Observable<any[]> {
    return this.http.get<any[]>(this.o3CorebaseUrl + 'NCR/getNCRTypes');
  }
  getImplementCapa(data): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/GetImplementCapa',
      data
    );
  }
  getCustomer(data: any): Observable<any[]> {
    return this.http.post<any>(
      this.o3CorebaseUrl + 'Customer/GetCustomerData',
      data
    );
  }
  changeNcrRecord(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/NCRrecord', data);
  }
  getFilteredData(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/getFilterNCRData',
      data
    );
  }
  getProcessOrder(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'Product/GetProcessOrder',
      data
    );
  }
  // getProcessOrder(data: any): Observable<any[]> {
  //   return this.http.post<any[]>(this.baseUrl + 'processOrder', data);
  // }
  getOperationNumber(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/Productionplan',
      data
    );
  }
  getUnitOfMeasurement(): Observable<any[]> {
    return this.http.get<any[]>(
      this.o3CorebaseUrl + 'NCR/GetUnitOfMeasurement'
    );
  }
  getUom(data: any): Observable<any[]> {
    return this.http.get<any[]>(
      this.o3CorebaseUrl + 'UnitOfMeasure_Core/GetAllUnitOfMeasurement'

    );
  }
  getQualityArea(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.O3CoreApiUrl + 'QualityArea/GetQualityAreaByPlantId',
      data
    );
  }

  ncrAction(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/addNCRActions',
      data
    );
  }
  getRCAStatus(data: any): Observable<any> {
    return this.http.post(this.o3CorebaseUrl + 'NCR/GetRCAStatus', data);
  }
  allncrAction(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/getAllNCRActions',
      data
    );
  }

  deletencraction(data: any): any {
    return this.http.post(this.o3CorebaseUrl + 'NCR/deleteNCRActions', data);
  }

  updateNcraction(data: any): any {
    // return this.http.put(this.baseUrl + 'user', register);
    return this.http.put(this.o3CorebaseUrl + 'NCR/updateNCRActions', data);
  }

  updateStatus(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/addNCRStatus', data);
  }

  updateRemarks(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/updateNCRRemarks',
      data
    );
  }
  ncractionexecutionUpdate(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/updateCapaNCRActions',
      data
    );
  }
  getncrspecification(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/getNcrSpecification',
      data
    );
  }

  getncrfiles(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/getNcrFiles', data);
  }
  addncrfiles(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/addNcrFiles', data);
  }

  deletencrfiles(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/deleteNcrFiles',
      data
    );
  }
  getFailureModeDetails(data: any): Observable<any[]> {
    return this.http.post<any[]>(
      this.o3CorebaseUrl + 'NCR/getAllFailureMode',
      data
    );
  }

  getNCRById(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.o3CorebaseUrl + 'NCR/GetNCRById', data);
  }

  reOpenNCR(data: any): Observable<any> {
    return this.http.post(this.o3CorebaseUrl + 'NCR/ReOpenNCR', data);
  }
  updateRCAStatus(data: any): Observable<any> {
    return this.http.put(this.o3CorebaseUrl + 'NCR/updateRCAStatus', data);
  }
  addnotification(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Roles/addnotificationsrolewise', data);
  }

  createNcrChlid(data: any): Observable<any> {
    return this.http.post<any>(this.O3CoreApiUrl + 'NCR/createNcrChild', data);
  }

  removeNcrChlid(data: any): Observable<any> {
    return this.http.get<any>(this.O3CoreApiUrl + 'NCR/removeNcrChild/?ncrId=' + data);
  }

  getNCRHeader(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'NCRReportConfiguration/GetNCRHeaderName', data);
  }

  ncrHeaderFooterConfiguration(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'NCRReportConfiguration/nCR_CRUD_HeaderFooterConfiguration', data);
  }

  submitCheckedNCRreportHeader(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'NCRReportConfiguration/addOrEdit_CheckedNCRReportHeader', data);
  }

  getNcrReportData(data: any): Observable<any> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'NCRReportConfiguration/ncrReportData', data);
  }

  getSubAndResultHeader(data: any): Observable<any[]> {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'NCRReportConfiguration/get_SubandResultHeader', data);
  }
  getLines(data) {
    return this.http.get<any[]>(this.O3CoreApiUrl + 'Dashboard/GetLineList', data);

  }
  getUnits(data) {
    return this.http.post<any[]>(this.O3CoreApiUrl + 'Dashboard/GetUnitList', data);

  }
  getNcrCategory(): Observable<any[]> {
    return this.http.get<any[]>(this.o3CorebaseUrl + 'NCR/GetNCRCategory');
  }
}
